import { Component, HostListener, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog-host',
  imports: [TranslateModule],
  template: `
    @if (dialog.current(); as request) {
      <div class="modal-backdrop z-[70]" role="dialog" aria-modal="true">
        <div class="modal p-6 w-96 max-w-full">
          <h2 class="text-lg font-semibold mb-4">{{ request.title || ('Confirm' | translate) }}</h2>
          <p class="mb-6 whitespace-pre-line">{{ request.message }}</p>
          @if (request.reason; as reason) {
            <label class="form-label" for="confirm-reason">{{ reason.label }}</label>
            <textarea id="confirm-reason" class="input mb-4 w-full" rows="3" maxlength="500" [value]="reason.value"
              (input)="reason.value = $any($event.target).value"></textarea>
          }
          <div class="flex justify-end gap-2">
            <button type="button" (click)="dialog.answer(false)" class="px-4 py-2 btn btn-secondary rounded">{{ 'Cancel' | translate }}</button>
            <button type="button" (click)="dialog.answer(true)" [disabled]="!!request.reason && !request.optional && !request.reason.value.trim()" class="px-4 py-2 btn btn-primary text-white rounded">{{ 'Confirm' | translate }}</button>
          </div>
        </div>
      </div>
    }
  `,
})
export class ConfirmDialogHostComponent {
  readonly dialog = inject(ConfirmDialogService);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.dialog.current()) this.dialog.answer(false);
  }
}
